import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function XCircle({ outline, ...props }: IconProps): JSX.Element {
  return outline ? (
    <XCircle.Outline {...props} />
  ) : (
    <XCircle.Solid {...props} />
  );
}

XCircle.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          d="M8.90906 8.90918C9.20785 8.61039 9.69218 8.61039 9.99097 8.90918L12 10.9182L14.0092 8.90904C14.308 8.61025 14.7923 8.61025 15.0911 8.90904C15.3899 9.20783 15.3899 9.69216 15.0911 9.99095L13.0819 12.0001L15.091 14.0092C15.3898 14.308 15.3898 14.7923 15.091 15.0911C14.7922 15.3899 14.3078 15.3899 14.009 15.0911L12 13.082L9.99106 15.091C9.69227 15.3896 9.20794 15.3896 8.90918 15.091C8.61043 14.7922 8.61043 14.3078 8.90918 14.009L10.9181 12.0001L8.90906 9.99106C8.61031 9.69227 8.61031 9.20794 8.90906 8.90918Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 22.2C17.6333 22.2 22.2 17.6333 22.2 12C22.2 6.36669 17.6333 1.8 12 1.8C6.36669 1.8 1.8 6.36669 1.8 12C1.8 17.6333 6.36669 22.2 12 22.2ZM12 20.67C16.7884 20.67 20.67 16.7884 20.67 12C20.67 7.21169 16.7884 3.33 12 3.33C7.21169 3.33 3.33 7.21169 3.33 12C3.33 16.7884 7.21169 20.67 12 20.67Z"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

XCircle.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <circle
          opacity="0.4"
          cx="12.5652"
          cy="12"
          r="10"
          className="icon-secondary"
        />
        <path
          d="M14.5349 8.96967C14.8278 8.67678 15.3026 8.67678 15.5955 8.96967C15.8884 9.26256 15.8884 9.73732 15.5955 10.0302L13.6257 11.9999L15.5955 13.9697C15.8883 14.2626 15.8883 14.7373 15.5955 15.0302C15.3026 15.3231 14.8278 15.3231 14.5349 15.0302L12.5652 13.0605L10.5955 15.0302C10.3026 15.3231 9.8278 15.3231 9.53491 15.0302C9.24203 14.7373 9.24202 14.2626 9.53491 13.9697L11.5046 11.9999L9.53491 10.0302C9.24203 9.73732 9.24202 9.26256 9.53491 8.96967C9.8278 8.67678 10.3026 8.67678 10.5955 8.96967L12.5652 10.9394L14.5349 8.96967Z"
          className="icon-primary"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
